import { render } from "./Sku.vue?vue&type=template&id=70c2ff0b"
import script from "./Sku.vue?vue&type=script&lang=js"
export * from "./Sku.vue?vue&type=script&lang=js"

import "./Sku.vue?vue&type=style&index=0&id=70c2ff0b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__